import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import QueueDefaultWidget from "@/components/dynamic/QueueDefaultWidget.vue";
import QueueLeafWidget from "@/components/dynamic/QueueLeafWidget.vue";
import { ref, computed, onMounted, nextTick } from "vue";

const __default__ = {
  name: "QueueDefaultWidget",
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    queueData: {},
    queueConfig: {},
    borderRadius: {},
    config: {}
  },
  setup(__props: any) {

const props = __props;

const template = computed(() => {
  if (!props.config.queueConfig.template) {
    return "boxes";
  }
  return props.config.queueConfig.template;
});

// queue data by maxRows ordered by statusUpdateTimestamp
const displayQueueData = computed(() => {
  const data = props.queueData ?? [];
  const raw = props.config?.queueConfig?.maxRows;
  const maxRows = typeof raw === "number" ? raw : Number(raw);
  if (raw == null || raw === undefined || Number.isNaN(maxRows)  || maxRows === 0 || maxRows <= 0) {
    return data;
  }
  const byTimestamp = [...data].sort((a, b) => {
    const ta = a?.statusUpdateTimestamp ?? 0;
    const tb = b?.statusUpdateTimestamp ?? 0;
    return tb - ta; // descending: most recent first
  });
  return byTimestamp.slice(0, maxRows);
});

//set counter and number text
const numberTxt = ref("");
const counterTxt = ref("");
const setHeaderText = () => {
  const displayData = JSON.parse(localStorage.getItem("display") || "{}");
  const config = JSON.parse(displayData.config);
  const voiceCall = config.voice_call;
  if (voiceCall == 1) {
    counterTxt.value = config.textCounter;
    numberTxt.value = config.textNumber;
  }else{
    const lang = localStorage.getItem("Language");
    if (lang == "fr") {
      counterTxt.value = "Guichet";
      numberTxt.value = "Numéro";
    }else if (lang == "en") {
      counterTxt.value = "Counter";
      numberTxt.value = "Number";
    }else{
      counterTxt.value = "شباك";
      numberTxt.value = "رقم";
    }
  }
}

onMounted(() => {
  setHeaderText();
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (template.value === 'boxes')
      ? (_openBlock(), _createBlock(QueueDefaultWidget, {
          key: 0,
          queueData: displayQueueData.value,
          queueConfig: _ctx.queueConfig,
          "border-radius": _ctx.borderRadius,
          numberTxt: numberTxt.value,
          counterTxt: counterTxt.value,
          config: _ctx.config
        }, null, 8, ["queueData", "queueConfig", "border-radius", "numberTxt", "counterTxt", "config"]))
      : _createCommentVNode("", true),
    (template.value === 'leaf')
      ? (_openBlock(), _createBlock(QueueLeafWidget, {
          key: 1,
          queueData: displayQueueData.value,
          queueConfig: _ctx.queueConfig,
          "border-radius": _ctx.borderRadius,
          numberTxt: numberTxt.value,
          counterTxt: counterTxt.value,
          config: _ctx.config
        }, null, 8, ["queueData", "queueConfig", "border-radius", "numberTxt", "counterTxt", "config"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})